import React, {useContext, useState, useEffect} from "react";
import {useDrop} from "react-dnd";
import update from "immutability-helper";
import Item from "../midSection/Item";
import StopIcon from "@material-ui/icons/Stop";
import PlayArrow from "@material-ui/icons/PlayArrow";
import FlowDrag from "./FlowDrag";
import {useTranslation} from "react-i18next";
import {DataContext} from "../FlowConfiguration";
import DiagramBuilderIcon from "../../../../../assets/icons/DiagramBuilder";
import Calculator from "../../../../../assets/icons/Calculator";
import {allActionSelectCancelled} from "../midSection/Item";
import {removeFromTree} from "../../../../../helpers/flowHelper";
import cloneDeep from "lodash/cloneDeep";
import {updateHistory} from "../../../../../helpers/historyHandler";
import {cutItem, pasteItem, copyItem} from "../../../../../helpers/ccp";
import {useSetRecoilState} from 'recoil';
import {alertState} from '../../../../../recoil-store/recoil-state';

const styles = {
    width: "100%",
    height: "100%",
    position: "relative",
};

let topFlow = 0;

const AllFlowDrag = (props) => {
    const {t} = useTranslation();
    const [isWheel, setIsWheel] = useState(false);
    const context = useContext(DataContext);
    const setAlert = useSetRecoilState(alertState);

    useEffect(() => {
        const el = document.getElementById("alt-area");
        el.addEventListener("wheel", (event) => {
            const flow = document.getElementById("drag-me");
            const delta = Math.sign(event.deltaY);
            const offsetChangeValue = 50;
            const elem = document.getElementById("flow-stop");

            if (elem !== undefined && elem !== null) {
                const topPosition = flow.offsetTop;
                const flowStop = elem.offsetTop;

                if (delta === -1) {
                    if (topPosition < el.offsetHeight - 250) {
                        flow.style.top =
                            (topPosition + offsetChangeValue).toString() + "px";
                        topFlow = topPosition + offsetChangeValue;
                        setIsWheel(true);
                    }
                } else {
                    if (topPosition > -flowStop + 150) {
                        flow.style.top =
                            (topPosition - offsetChangeValue).toString() + "px";
                        topFlow = topPosition - offsetChangeValue;
                        setIsWheel(true);
                    }
                }
            }
        });


        el.addEventListener("keydown", (event) => {
            const flow = document.getElementById("drag-me");
            let offsetChangeValue = 50;
            const elem = document.getElementById("flow-stop");
            const actions = document.getElementsByClassName("drag-container-area")[0];
            if (actions?.offsetHeight > 100 && actions?.offsetHeight < 250) offsetChangeValue = 100;
            else if (actions?.offsetHeight > 250 && actions?.offsetHeight < 500) offsetChangeValue = 200;
            else if (actions?.offsetHeight > 500 && actions?.offsetHeight < 750) offsetChangeValue = 325;
            else if (actions?.offsetHeight > 750 && actions?.offsetHeight < 1000) offsetChangeValue = 450;
            else if (actions?.offsetHeight > 1000 && actions?.offsetHeight < 1500) offsetChangeValue = 550;
            else if (actions?.offsetHeight > 1500 && actions?.offsetHeight < 2000) offsetChangeValue = 650;
            else if (actions?.offsetHeight > 2000 && actions?.offsetHeight < 2500) offsetChangeValue = 750;
            else if (actions?.offsetHeight > 2500 && actions?.offsetHeight < 3050) offsetChangeValue = 850;
            else if (actions?.offsetHeight > 3050 && actions?.offsetHeight < 4050) offsetChangeValue = 950;
            else if (actions?.offsetHeight > 4050 && actions?.offsetHeight < 5050) offsetChangeValue = 1100;
            else if (actions?.offsetHeight > 5050 && actions?.offsetHeight < 7050) offsetChangeValue = 1300;
            else if (actions?.offsetHeight > 7050 && actions?.offsetHeight < 10500) offsetChangeValue = 1500;
            else if (actions?.offsetHeight > 10500 && actions?.offsetHeight < 15000) offsetChangeValue = 1700;
            else if (actions?.offsetHeight > 15000) offsetChangeValue = 2000;
            if (elem !== undefined && elem !== null) {
                const topPosition = flow.offsetTop;
                const flowStop = elem.offsetTop;
                if (event.ctrlKey && event.keyCode === 35) {
                    if (topPosition > -flowStop + 150) {
                        flow.style.top =
                            (topPosition - offsetChangeValue).toString() + "px";
                        topFlow = topPosition - offsetChangeValue;
                        setIsWheel(true);
                    }
                } else if (event.ctrlKey && event.keyCode === 36) {
                    if (topPosition < el.offsetHeight - 250) {
                        flow.style.top =
                            (topPosition + offsetChangeValue).toString() + "px";
                        topFlow = topPosition + offsetChangeValue;
                        setIsWheel(true);
                    }
                }
            }
        })


    }, []);

    // all drag area = object
    const [boxes, setBoxes] = useState({
        a: {top: 20, left: 50},
    });
    const [, drop] = useDrop({
        accept: "allFlow",
        drop(item, monitor) {
            const delta = monitor.getDifferenceFromInitialOffset();
            if (delta !== null) {
                const left = Math.round(item.left + delta.x);
                let top;

                // mouse wheel is scrolling
                if (isWheel) {
                    top = Math.round(topFlow + delta.y);
                    setIsWheel(false);
                }
                // mouse wheel isn't   scrolling
                else {
                    top = Math.round(item.top + delta.y);
                }
                props.setIsMove(true);
                moveBox(item.id, left, top);
            }
            context.beginDrag = false;
        },
    });

    //  moved all drag area
    const moveBox = (id, left, top) => {
        if (id !== undefined && left !== undefined && top !== undefined) {
            setBoxes(
                update(boxes, {
                    [id]: {
                        $merge: {left, top},
                    },
                })
            );
        }
    };

    const directDiagramBuilder = () => {
        props.setIsDiagramBuilder(false);
        localStorage.setItem("tabs", "diagram");
    };

    function handleStop(e) {
        if (!e) var e = window.event;
        e.cancelBubble = true;
        if (e.stopPropagation) e.stopPropagation();
        context.setSelected(context.initialFlowItem[0]);
        props.setOpen(true);
    }

    function handleDeSelect(e) {
        context.setSelected({});
        context.setMoreSelected([]);
        allActionSelectCancelled(context.items.children);
        props.setOpen(false);
    }

    function handleKeyDown(event) {
        let charCode = String.fromCharCode(event.which).toLowerCase();
        if (event.ctrlKey && event.shiftKey && charCode === "v") {
            if (context.moreSelected[0]?.flow_behavior?.includes("groupable")) {
                pasteItem("flow", context, context.moreSelected[0], true);
                props.setRender(true);
            }
        } else if (event.keyCode === 46) {
            if (context.moreSelected[0]?.actionName?.length > 0) {
                let selectedAction = [];
                let clone = cloneDeep(context.items);
                if (context.moreSelected.length > 1) {
                    let copiedItems = cloneDeep(context.moreSelected);
                    for (let i = 0; i < copiedItems.length; i++) {
                        removeFromTree(clone, copiedItems[i].id, selectedAction);
                    }
                    updateHistory("flow", clone);
                }
                removeFromTree(clone, context.moreSelected[0].id, selectedAction);
                if (selectedAction[0]?.actionName === "Start") {
                    context.setSelected({});
                } else {
                    context.setSelected(selectedAction[0]);
                }
                updateHistory("flow", clone);
                context.setItems(clone);
            }
        } else if (event.ctrlKey && charCode === "x") {
            let selectedAction = [];
            let clone = cloneDeep(context.items)
            if (context.moreSelected.length >= 1) {
                let copiedItems = cloneDeep(context.moreSelected);
                for (let i = 0; i < copiedItems.length; i++) {
                    removeFromTree(clone, copiedItems[i].id, selectedAction);
                }
                updateHistory("flow", clone);
                cutItem("flow", copiedItems, context);
            }
            if (selectedAction[0]?.actionName === "Start") {
                context.setSelected({});
            } else {
                context.setSelected(selectedAction[0]);
            }
            context.setItems(clone)
        } else if (event.ctrlKey && charCode === "v") {
            if (context.moreSelected.length === 0) {
                pasteItem("flow", context, context.items.children[context.items.children.length - 1]);
            } else {
                pasteItem("flow", context, context.moreSelected[0]);
            }
        } else if (event.ctrlKey && charCode === "c") {
            if (context.moreSelected.length > 0) {
                copyItem(context.moreSelected);
                setAlert(alert => ({
                    ...alert,
                    show: true,
                    message: t("MESSAGES.AUTOMS.AUTOM-COPIED"),
                    severity: 'success'
                }))
            }
        } else {
            return;
        }
    }

    // dropping all drag area
    return (
        <div
            className="all-flow-drag"
            ref={drop}
            style={styles}
            onClick={() => handleDeSelect()}
            tabIndex="0"
            onKeyDown={handleKeyDown}
        >
            <button className="diagram-flow-button" onClick={directDiagramBuilder}>
                <DiagramBuilderIcon/>
                <span>{t("CONTENT.FLOW.DIAGRAM")}</span>
            </button>
            <button
                className="diagram-flow-button roi-button"
                onClick={() => props.setOpenRoi(true)}
            >
                <Calculator/>
                <span>{t("CONTENT.FLOW.ROI")}</span>
            </button>
            <div id="show-display-message"></div>
            {Object.keys(boxes).map((key) => {
                const {left, top} = boxes[key];
                return (
                    <FlowDrag
                        left={left}
                        top={top}
                        id={key}
                        key={key}
                        scale={props.scale}
                    >
                        <div className="drag-container-area">
                            <div
                                onClick={() => handleDeSelect()}
                                id="flow-start"
                                className="drag-container-button color-green none-hover"
                            >
                                <PlayArrow/> <span>{t("CONTENT.FLOW.START")}</span>
                            </div>
                            <Item
                                key={key}
                                info={props.items}
                                render={props.render}
                                setRender={props.setRender}
                                setOpen={props.setOpen}
                                libraryData={props.libraryData}
                                debuggingStart={props.debuggingStart}
                                groupLabel={props.groupLabel}
                                open={props.open}
                            />
                            <div
                                id="flow-stop"
                                onClick={handleStop}
                                className="drag-container-button color-red none-hover"
                            >
                                <StopIcon/> <span>{t("CONTENT.FLOW.STOP")}</span>
                            </div>
                        </div>
                    </FlowDrag>
                );
            })}
        </div>
    );
};

export default AllFlowDrag;
